<template>
  <div class="card-container" v-if="loaded">
    <order-card :id="$route.params.id" :initData="data" />
  </div>
  <GMapMap :center="center" :options="options" ref="map" :zoom="zoom" class="map" v-if="loaded">
    <GMapCluster>
      <GMapMarker :icon="{
        url: require('@/assets/map/pickup-pin.svg'),
        scaledSize: { width: 34, height: 42 },
      }" :position="{
        lat: data.pick_up_location.coordinates[1],
        lng: data.pick_up_location.coordinates[0],
      }" />
      <GMapMarker v-if="data.pull_down_location" :icon="{
        url: require('@/assets/map/dropoff-pin.svg'),
        scaledSize: { width: 34, height: 42 },
      }" :position="{
        lat: data.pull_down_location.coordinates[1],
        lng: data.pull_down_location.coordinates[0],
      }" />
      <GMapMarker :icon="{
        url: require('@/assets/map/car.png'),
        scaledSize: { width: 48, height: 40 },
      }" :position="{
        lat: driver.lat,
        lng: driver.lng,
      }" />
    </GMapCluster>
  </GMapMap>
</template>
<script>
/* eslint-disable */

import OrderCard from "@/components/OrderCard.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import axios from "axios";

const options = {
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  styles: [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#a3a4ae",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#e6eaf0",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "simplified",
        },
        {
          gamma: "2",
        },
        {
          lightness: "3",
        },
        {
          color: "#778494",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [
        {
          color: "#788E98",
        },
      ],
    },
    {
      featureType: "poi.attraction",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ceead6",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#39b65c",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          saturation: "0",
        },
        {
          lightness: "35",
        },
        {
          visibility: "simplified",
        },
        {
          gamma: "1",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fde293",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
        {
          saturation: "-50",
        },
        {
          lightness: "17",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#8fbaff",
        },
        {
          visibility: "on",
        },
      ],
    },
  ],
};

// {
//   position: {
//     lat: 43.738359,
//     lng: 7.426723,
//   },
//   icon: {
//     url: require("@/assets/map/pickup-pin.svg"),
//     scaledSize: {
//       width: 34,
//       height: 42,
//     },
//   },
// },


export default {
  components: { OrderCard },
  title: "Order # Details",
  mixins: [socketEventsMixin],
  events() {
    return {
      driver_tracking: this.changeLocation,
      "Passengers:booking_updated": this.changeOrderStatus,
    };
  },
  data() {
    return {
      data: null,
      zoom: 16,
      center: { lat: 43.738359, lng: 7.426723 },
      options: options,
      driver: { lat: 0, lng: 0 },
      map: null,
    };
  },
  computed: {
    loaded() {
      return this.data !== null ? true : false;
    },
    enableTracking() {
      if (this.loaded)
        return [!!this.data.now && "ACCEPTED", "STARTED"].includes(this.data.status);
      else return false;
    },
  },
  methods: {
    changeLocation(data) {
      if (this.enableTracking) {
        this.driver.lat = data.lat;
        this.driver.lng = data.lng;
        window.requestAnimationFrame(() => {
          this.map.$mapPromise.then((map) => {
            if (this.data) {
              let zoomLvl = map.getZoom();
              const bounds = new google.maps.LatLngBounds();
              bounds.extend({
                  lat: this.driver.lat,
                  lng: this.driver.lng,
                });
              map.fitBounds(bounds);
              map.setZoom(zoomLvl);
            }
          });
        });


      }
    },
    changeOrderStatus({ booking_id, status, driver }) {
      if (this.data.id == booking_id) {
        if (driver) {
          this.data.status = status;
          this.data.captain_name = driver.first_name;
          this.data.taxi_number = driver.username;
          this.data.captain_phone_number = driver.phone_number;
          this.data.car_brand_model = driver.car_brand_model;
          this.data.car_brand = driver.car_brand;
          this.data.car_color = driver.car_color;
          this.data.car_plate_number = driver.car_plate_number;
        } else this.data.status = status;
      }
    },
    getOrderDetails() {
      return new Promise((resolve, reject) => {
        axios
          .get(this.$store.state.rootAPI + "booking/" + this.$route.params.id)
          .then((res) => {
            this.data = res.data.data;
            if (this.data.captain_location)
              this.changeLocation(this.data.captain_location)
            resolve();
          })
          .catch((error) => {
            this.$router.push({ name: "PlaceOrder" });
            this.$notify({
              title: "Error",
              text: error,
              type: "error",
            });
            reject();
          })
          .finally(() => {
            document.title = `Order #${this.data.id} Details | Snap Drive`;
          });
      });
    },
    zoomUI(map) {
      // Container

      const zoomUIContainer = document.createElement("div");
      zoomUIContainer.classList = "zoom-container";

      // Zoom in

      const zoomIn = document.createElement("button");
      zoomIn.classList = "zoom-button";
      zoomIn.title = "Click to zoom in";

      const zoomInText = document.createElement("div");
      zoomInText.innerHTML = `+`;
      zoomIn.appendChild(zoomInText);

      zoomUIContainer.append(zoomIn);

      zoomIn.addEventListener("click", () => {
        map.setZoom(map.getZoom() + 1);
      });

      // Zoom out

      const zoomOut = document.createElement("button");
      zoomOut.classList = "zoom-button";
      zoomOut.title = "Click to zoom out";

      const zoomOutText = document.createElement("div");
      zoomOutText.innerHTML = `-`;
      zoomOut.appendChild(zoomOutText);

      zoomUIContainer.append(zoomOut);

      zoomOut.addEventListener("click", () => {
        map.setZoom(map.getZoom() - 1);
      });

      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomUIContainer);
    }
  },
  mounted() {
    if (this.$route.params.data) {
      this.data = JSON.parse(this.$route.params.data);
      window.requestAnimationFrame(() => {
        this.map = this.$refs.map;
      });
      document.title = `Order #${this.data.id} Details | Snap Drive`;
    } else if (this.$route.params.id) {
      this.getOrderDetails().then(() => { this.map = this.$refs.map });
    } else {
      this.$router.push({ name: "PlaceOrder" });
    }
  },
  watch: {
    map: function (googleMap) {
      googleMap.$mapPromise.then((map) => {
        this.zoomUI(map);
        const bounds = new google.maps.LatLngBounds();
        if (this.data) {
          if (this.driver.lat && this.driver.lng) {
            bounds.extend({
              lat: this.driver.lat,
              lng: this.driver.lng,
            });
          }
          else {
            bounds.extend({
              lat: this.data.pick_up_location.coordinates[1],
              lng: this.data.pick_up_location.coordinates[0],
            });
           
          }

          map.fitBounds(bounds);
          google.maps.event.addListenerOnce(map, 'idle', () => {
                  map.setZoom(this.zoom);
                });
        }
      });
    },
  },
};
</script>

<style>
.card-container {
  width: 325px;
  position: absolute;
  z-index: 4;
  bottom: 20px;
  left: 55px;
}

.map {
  height: calc(100vh - 64px);
}

.zoom-container {
  width: max-content;
  height: max-content;
  bottom: 20px !important;
  right: 55px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.zoom-button {
  height: 48px;
  width: 48px;
  background-color: #fff;
  border: 1px solid #c1c5d8;
  color: #222629;
  font-size: 18px;
  border-radius: 10px;
  outline: none;
}
</style>